export default function (firstname, lastname, displayName, email) {
  if (firstname && lastname) {
    return [firstname, lastname]
  } else if (displayName) {
    return displayName.split(' ')
  } else if (email) {
    return email.split('.')
  }
}
